import React from 'react';

import { useIntl } from 'react-intl';

import { MethodType } from './styled';

const SodexoMethod = () => {
  const { formatMessage } = useIntl();

  return <MethodType>{formatMessage({ id: 'payWithSodexoVoucher' })}</MethodType>;
};

export default SodexoMethod;
